import(/* webpackMode: "eager" */ "D:\\a\\_work\\1\\s\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager" */ "D:\\a\\_work\\1\\s\\node_modules\\bootstrap\\dist\\css\\bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "D:\\a\\_work\\1\\s\\node_modules\\bootstrap-icons\\font\\bootstrap-icons.css");
;
import(/* webpackMode: "eager" */ "D:\\a\\_work\\1\\s\\node_modules\\leaflet\\dist\\leaflet.css");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationProvider"] */ "D:\\a\\_work\\1\\s\\src\\contexts\\OrganizationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\a\\_work\\1\\s\\src\\layout\\ClientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "D:\\a\\_work\\1\\s\\src\\providers\\theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "D:\\a\\_work\\1\\s\\src\\styles\\globals.scss");
